export default __webpack_public_path__ + "static/media/voucher.f69e5b3f.svg";